import { Layout } from "antd";
import { NavBar } from "components/";
import { Outlet, Navigate } from "react-router-dom";
import { isUserLoggedIn } from "utils";
import img from "assets/images/background.jpg";

const { Content } = Layout
export default function PublicLayout() {
    if (isUserLoggedIn()) {
        return <Navigate to='/' />
    }
    return (
        <Layout >
            <NavBar />
            <Content className="public-page" style={{ backgroundImage: `url(${img})`}}>
                <Outlet />
            </Content>
        </Layout>
    )
}